import React from "react";
import { Modal, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import classes from "./ModalDeleteBanner.module.scss";
import { useBannerActions } from "../AddBanner/hooks/useBannerActions";
import ButtonActions from "../../../Components/Buttons/ButtonActions/ButtonActions";

const { Title, Paragraph } = Typography;
const ModalDeleteBanner = ({
  setModalDelete,
  modalDelete,
  selectedBanner,
  handleDelete,
}) => {
  const { deleteBanner, buttonDeleteDisable } = useBannerActions();

  return (
    <Modal
      width={1000}
      height={407}
      open={modalDelete}
      className={classes.modal}
      onCancel={() => setModalDelete(false)}
      footer={
        <div className={classes.footerButton}>
          <ButtonActions
            variant="outline"
            onClick={() => setModalDelete(false)}
            text="Cancelar"
          />

          <ButtonActions
            variant="danger"
            disabled={buttonDeleteDisable}
            text="Confirmar exclusão"
            onClick={() => {
              deleteBanner(selectedBanner?.banner_id);
            }}
          />
        </div>
      }
      closeIcon={<CloseOutlined className={classes.closeButton} />}
    >
      <Title level={4} className={classes.modalTitle}>
        Confirmar exclusão
      </Title>
      <Paragraph className={classes.modalParagraph}>
        Deseja excluir o Banner{" "}
        <strong style={{ fontWeight: "700" }}>
          {selectedBanner?.banner_name}
        </strong>{" "}
        ? <br />
        Após a exclusão, ele não poderá ser recuperado.
      </Paragraph>
    </Modal>
  );
};

export default ModalDeleteBanner;
